export default "__VITE_ASSET__XywbUcgP__"